module.exports = __webpack_public_path__ + "img/faqIcon.22a36ef8.svg";